import { IFormField, IFormSection } from "../../../../../shared/components/web-form/web-form.objects";
import _ from "lodash";

export class OtherTypeInputField implements IFormField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    formSection: IFormSection;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    //institutionDropdownId: string;
    currentDropdownSelector: string;
    otherValue: string;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, currentDropdownSelector: string,
        otherValue: string = "-99")
    {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;

        //this.institutionDropdownId = "#institution-type-select";
        this.currentDropdownSelector = currentDropdownSelector;
        this.otherValue = otherValue;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;
        this.initializeSectionUpdateTrigger();
    }

    private initializeSectionUpdateTrigger() {
        $(`#${this.fieldId}`).on("keyup change", () => {
            this.triggerSectionUpdate();
        });
    }

    private getInput(): string {
        let input = (<string>$(`#${this.fieldId}`).val()).trim();
        return input;
    }

    private setInput(data: any): void {
        $(`#${this.fieldId}`).val(data);
    }

    //private getDropdownVal(): string {
    //    let institutionDropdownVal = <string>$(this.institutionDropdownId).val();
    //    return institutionDropdownVal;
    //}
    private getDropdownVal(): string {
        return <string>$(this.currentDropdownSelector).val();
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getInput();
        let dropdownVal = this.getDropdownVal();

        if (dropdownVal == "-99") {
            if (!val) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getInput();
        if (val != this.defaultVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}

